import timeOffBalances from '@/data/timeOffAccrual/reducers/timeOffBalanceReducer';
import timeOffPolicies from '@/data/timeOffAccrual/reducers/timeOffPolicyReducer';

import { combineReducers } from '@reduxjs/toolkit';

export default combineReducers({
  balances: timeOffBalances,
  policies: timeOffPolicies,
});
